// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {AVIF_FORMAT_LABEL} from '@app/features/app/config/I18nDisplayConstants';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import type {I18n} from '@lingui/core';
import {msg} from '@lingui/core/macro';
import {Trans} from '@lingui/react/macro';

interface ShowAnimatedAvifConfirmModalOptions {
	onConfirm: () => void;
	i18n: I18n;
}
export function showAnimatedAvifConfirmModal({onConfirm, i18n}: ShowAnimatedAvifConfirmModalOptions): void {
	ModalCommands.push(
		modal(() => (
			<ConfirmModal
				title={i18n._(msg`Animated ${AVIF_FORMAT_LABEL} Not Supported`)}
				description={
					<Trans>
						Cropping and rotating animated {AVIF_FORMAT_LABEL} files isn't supported yet. If you proceed with uploading
						this file, it will be uploaded in its original form without any modifications.
					</Trans>
				}
				primaryText={i18n._(msg`Upload As-Is`)}
				primaryVariant="primary"
				secondaryText={i18n._(msg`Cancel`)}
				onPrimary={onConfirm}
			/>
		)),
	);
}
